module.exports = __webpack_public_path__ + "img/overheads-taxes.5c11cb30.svg";